
import { createGlobalState } from 'react-hooks-global-state';

const initialState = { isLoggedin: localStorage.getItem('user') ? true : false };
export const { useGlobalState } = createGlobalState(initialState);